$(document).ready(function(){
updateCurrencyValue();
  setInterval(function (){
   updateCurrencyValue()
   setInterval(updateCurrencyValue(), 10);
  },1500)

  var $form = $('form#shipping-calculator');
  $('.js-shipping-calc-submit').on('click', function(e) {
    e.preventDefault(); // Prevent the form from submitting normally
  
    var formData = $form.serialize();
  
    $.ajax({
      type: 'POST',
      url: '/cart/shipping_rates.json', 
      data: formData,
      dataType: 'json',
      success: function(response) {
        console.log(response);
      },
      error: function(xhr, status, error) {
        console.log('Error: ' + error);
      }
    });
  });
  
  
  $(".drawer__close, .overlay_open_cart").click(function(){
  	$(".overlay_open_cart").addClass("d-none");
  });

  $(".currency-picker").click(function(){
     if($(".curr_Arrow").hasClass("currency-picker-open")){
       $(".curr_Arrow").removeClass("currency-picker-open");
       $(".curr_Arrow").addClass("currency-picker-closed");
     }else{
       $(".curr_Arrow").removeClass("currency-picker-closed");
       $(".curr_Arrow").addClass("currency-picker-open");
     }
  });

  var interval = setInterval(myTimer, 10, $(this));
  function myTimer(element) {
    thumbnailSliderResponsive();
    if($(".thumbnail-slider").height() == $(".product-main-image.selected").height()){
    clearInterval(interval);
    }
  }
  
   $(window).on('resize', function() {
   thumbnailSliderResponsive();
  });

  $(".product-thumbnail").click(function(){
    $(".product-main-image.selected").removeClass("selected");
    var imageId = $(this).attr('data-image-id');
    $("[data-image-id='"+imageId+"']").addClass("selected");
  });

  if(window.matchMedia("(max-width: 980px)").matches){
    $(".mobile-menu-content .submenu").addClass("d-none");
  } else{
    $(".desktop-menu-content .submenu").removeClass("d-none");
  }


  $(".swatch-element").click(function() {
    var labelValue = $(this).find("label").attr("value");
    var matchingElements = $("#" + labelValue);
    var selectElement = document.querySelector(".product-form .select select");

    var options = selectElement.getElementsByTagName("option");
    for (var i = 0; i < options.length; i++) {
        options[i].removeAttribute("selected");
    }

    if (matchingElements.length > 0) {
      matchingElements.each(function() {
        $(this).attr("selected", "selected");
      });
    } 
  });

});

function updateCurrencyValue() {
   $("#shopify-section-product-recommendations .money").each(function() {
      var converted = Currency.convert($(this).attr("value"), defaultCurrency, Currency.currentCurrency);
      var format = Currency.moneyFormats[Currency.currentCurrency][Currency.format];
      $(this).html(Currency.formatMoney(converted, format));
  });
}

function thumbnailSliderResponsive(){
  if($(".product-page.product-template").length > 0){
    var prodImageHeight = $(".product-image-container").innerHeight();
    if(prodImageHeight != 0){
      $(".thumbnail-slider").height(prodImageHeight);
    }else {
      $(".thumbnail-slider").height("1%");
    }
  }
}

// ---------------------MENU MOBILE--------------------------------
document.addEventListener('DOMContentLoaded', function() {
  var menuHandle = document.querySelector('.shifter-handle');
  var mobileMenuContent = document.querySelector('.mobile-menu-content');

  menuHandle.addEventListener('click', function() {
    mobileMenuContent.classList.toggle('active');
    if($(".mobile-menu-content").hasClass("active")){
        $("body").addClass("position_relative");
        $("body, html").addClass("overflow_hidden");
        
      }else{
        $("body").removeClass("position_relative");
        $("body, html").removeClass("overflow_hidden");
      }
  });

  $('.mobile-menu-content .dlinks.top_level').click(function(){
     $(this).toggleClass('active');
    if($(this).hasClass("open")){
       $(this).removeClass("open");
       $(this).parent().find(".submenu").addClass("d-none");
    }else {
      $(this).addClass("open");
      $(this).parent().find(".submenu").removeClass("d-none");
    }
  });
 
});

//-------------------------------------------------------------------------

